import {
	colorPalette,
	fontSize,
	fontWeight,
	mainLinks,
	supporter,
	fontFamily,
} from '../../config';
import {
	participateLogoImg,
	recogLogoImg,
	infoLogoImg,
	recordLogoImg,
	notifyLogoImg,
	support1,
	support2,
	cbsImg,
	gyeongSangImg,
	jinjuImg,
	courseImg,
} from '../../config/images';

const dateTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl5,
			tablet: '30px',
			mobile: '24px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
	unit: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '20px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		opacity: 0.64,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
	value: {
		fontSize: {
			desktop: fontSize.xl7,
			tablet: '44px',
			mobile: '38px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
};

export const firstProps = {
	titlenum: {
		type: 'p',
		children: `제25회`,
		fontSize: {
			desktop: '24px',
			tablet: '20px',
			mobile: '15px',
		},
		color: colorPalette.secondary,
		fontWeight: fontWeight.bold,
	},
	title: {
		type: 'h2',
		children: `순천남승룡마라톤`,
		fontSize: {
			desktop: '71px',
			tablet: '50px',
			mobile: '36px',
		},
		fontFamily: 'Gmarket',
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
	},
	content: {
		type: 'p',
		children: `2025.11.08 (토)`,
		fontSize: {
			desktop: '35px',
			tablet: '35px',
			mobile: '18px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
	},
	button: {
		text: {
			children: '신청하기',
			fontSize: {
				desktop: '24px',
				tablet: '24px',
				mobile: '16px',
			},
			lineHeight: 2.5,
			color: colorPalette.white,
			fontWeight: fontWeight.medium,
		},
		onClick: () =>
			(window.location.href = `${window.location.origin}/participation/person`),
		isRounded: true,
		bgColor: colorPalette.primary,
	},
	date: {
		title: {...dateTextProps.title, children: '행사 시작까지'},
		day: {...dateTextProps.unit, children: 'DAY'},
		dayValue: {...dateTextProps.value, children: '14'},
		hour: {...dateTextProps.unit, children: 'HOUR'},
		hourValue: {...dateTextProps.value, children: '8'},
		minute: {...dateTextProps.unit, children: 'MINUTES'},
		minuteValue: {...dateTextProps.value, children: '25'},
		second: {...dateTextProps.unit, children: 'SECONDS'},
		secondValue: {...dateTextProps.value, children: '32'},
	},
};

const secondTextProps = {
	title: {
		fontSize: {
			desktop: '26px',
			tablet: '26px',
			mobile: '26px',
		},
		color: colorPalette.primary,
		fontWeight: fontWeight.medium,
		fontFamily: 'Gmarket',
	},
	content: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		color: colorPalette.noneBorder,
		fontWeight: fontWeight.base,
		fontFamily: 'Gmarket',
	},
	support: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '15px',
		},
		color: colorPalette.base,
		fontWeight: fontWeight.semiBold,
	},
};

export const secondProps = {
	info: {
		title: {
			...secondTextProps.title,
			children: '마라톤 알아보기',
		},
		content: {
			...secondTextProps.content,
			children: `마라톤에 도움이 되는 바로가기\n정보를 안내합니다.`,
		},
		links: mainLinks,
	},
	supports: supporter,
};

export const thirdTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '26px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
	},
	item: {
		title: {
			fontSize: {
				desktop: '20px',
				tablet: '18px',
				mobile: '18px',
			},
			color: colorPalette.realBlack,
			fontWeight: fontWeight.bold,
			lineHeight: '30px',
		},
		content: {
			fontSize: {
				desktop: '20px',
				tablet: '16px',
				mobile: '16px',
			},
			color: colorPalette.realBlack,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
		smalContent: {
			fontSize: {
				desktop: fontSize.base,
				tablet: '16px',
				mobile: '16px',
			},
			color: colorPalette.tertiary,
			fontWeight: fontWeight.medium,
		},
		accentContent: {
			fontSize: {
				desktop: '20px',
				tablet: '18px',
				mobile: '16px',
			},
			color: colorPalette.tertiary,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
			whiteSpace: 'pre-wrap',
		},
	},
};

export const thirdProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.white,
		height: '3px',
		text: {...thirdTextProps.title, children: '대회요강', type: 'p'},
		description: {
			...thirdTextProps.description,
			children: '반드시 참가 유의사항을 읽고 신청해 주세요.',
		},
	},
	first: [
		{
			title: {...thirdTextProps.item.title, children: '대회명'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `2026 GIVE RUN in 나주`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '대회일시'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `2026년 4월 25일 (토)`,
				},
				{
					...thirdTextProps.item.content,
					children: (
						<>
							<div
								style={{
									textAlign: 'right',
									display: 'inline-block',
								}}
							>
								10km 1조 : 09:00
								<br />
								10km 2조 : 09:10
								<br />
								5km : 09:20
							</div>
						</>
					)
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '집결시간'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `오전 8시 30분`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '장소'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `나주 영산강정원\n(전남 나주시 영산동 757-1)`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가구분'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `10km코스(기록칩ㅇ) / 5km코스(기록칩X)`,
				},
				{
					...thirdTextProps.item.content,
					children: `2가지 코스 중 선택 가능`,
				},
			],
		},
	],
	second: [
		{
			title: {...thirdTextProps.item.title, children: '참가자격'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `나이제한 없으며, 신체 건강한 남 / 녀`,
				},
				// {
				// 	...thirdTextProps.item.smalContent,
				// 	children: `대한육상경기연맹 등록선수 및 선수등록 말소 후\n2년 경과되지 않은 자는 시상에서 제외됩니다.`,
				// },
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수기간'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `선착순 마감(4월 10일 최종마감)`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수방법'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `인터넷으로만 접수`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '모집인원'},
			contents: [
				{
					...thirdTextProps.item.accentContent,
					children: (
						<>
							<div
								style={{
									textAlign: 'right',
									display: 'inline-block',
								}}
							>
								10km(2,300명)
								<br />
								5km(1,700명)
							</div>
						</>
					),
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가비'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: (
						<>
							<div
								style={{
									textAlign: 'right',
									display: 'inline-block',
								}}
							>
								10km - 40,000원
								<br />
								5km - 40,000원
							</div>
						</>
					),
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '입금은행'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `기업은행 382-058691-04-021\n주식회사 남도기획`,
				},
				// {
				// 	...thirdTextProps.item.smalContent,
				// 	children: `\n* 7일 이내 입금 요망. 미입금 시 신청이 취소됩니다.`,
				// },
			],
		},
	],
};

const fourthTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '24px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.black,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: ' 16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.engTitle,
	},
};

export const fourthProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {...fourthTextProps.title, children: '대회코스', type: 'p'},
		description: {
			...fourthTextProps.description,
			children: '대회 구간을 참고하시고 신청 바랍니다',
		},
	},
	course: {
		src: courseImg,
		alt: '코스',
		borderRadius: '1.375rem',
	},
};

export const modalProps = {
	isClose: true,
	imgs: [{src: courseImg}, {src: ''}],
};
